import React, { Component } from 'react';
import Key from '../Key';
import {testKeyFromArr} from '../Key';

var keys = [
  'Q',
  'W',
  'E',
  'R',
  'T',
  'Y',
  'U',
  'I',
  'O',
  'P',
  'A',
  'S',
  'D',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'Z',
  'X',
  'C',
  'V',
  'B',
  'N',
  'M',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  '.',
  '@',
  '_',
  '-'
]

var Keyboard = React.createClass({

  handleClick: function(data){
    this.props.actionSaveField(this.props.text + data)
  },
  handleErase: function(data){
      this.props.actionSaveField(this.props.text.replace(/.$/, ''))
  },
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      if(nextProps.opperativeKey.keyCode == '8'){
        this.handleErase();
        return;
      }
      if(typeof nextProps.opperativeKey.key != 'undefined'){
        if(testKeyFromArr(nextProps.opperativeKey.key, keys)){
          this.handleClick(nextProps.opperativeKey.key)
        }
      }
      
    }
  },
  render: function(){
    if(!this.props.mobile){
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters lat">
            <Key actionClickButton={this.handleClick} val="Q" />
            <Key actionClickButton={this.handleClick} val="W" />
            <Key actionClickButton={this.handleClick} val="E" />
            <Key actionClickButton={this.handleClick} val="R" />
            <Key actionClickButton={this.handleClick} val="T" />
            <Key actionClickButton={this.handleClick} val="Y" />
            <Key actionClickButton={this.handleClick} val="U" />
            <Key actionClickButton={this.handleClick} val="I" />
            <Key actionClickButton={this.handleClick} val="O" />
            <Key actionClickButton={this.handleClick} val="P" />
            <Key actionClickButton={this.handleClick} val="A" />
            <Key actionClickButton={this.handleClick} val="S" />
            <Key actionClickButton={this.handleClick} val="D" />
            <Key actionClickButton={this.handleClick} val="F" />
            <Key actionClickButton={this.handleClick} val="G" />
            <Key actionClickButton={this.handleClick} val="H" />
            <Key actionClickButton={this.handleClick} val="J" />
            <Key actionClickButton={this.handleClick} val="K" />
            <Key actionClickButton={this.handleClick} val="L" />
            <Key actionClickButton={this.handleClick} val="." />
            <Key actionClickButton={this.handleClick} val="Z" />
            <Key actionClickButton={this.handleClick} val="X" />
            <Key actionClickButton={this.handleClick} val="C" />
            <Key actionClickButton={this.handleClick} val="V" />
            <Key actionClickButton={this.handleClick} val="B" />
            <Key actionClickButton={this.handleClick} val="N" />
            <Key actionClickButton={this.handleClick} val="M" />
            <Key actionClickButton={this.handleClick} val="9" />
            <Key actionClickButton={this.handleClick} val="@" />
            <Key actionClickButton={this.handleClick} val="0" />
            {this.props.handleOpenEnglish ? (
              <div className="button next" style={{width: 192}} onClick={this.props.handleOpenEnglish}>Назад</div>
            ) : (
              <div>
                <Key actionClickButton={this.handleClick} val="1" />
                <Key actionClickButton={this.handleClick} val="2" />
              </div>
            )}
            <Key actionClickButton={this.handleClick} val="3" />
            <Key actionClickButton={this.handleClick} val="4" />
            <Key actionClickButton={this.handleClick} val="5" />
            <Key actionClickButton={this.handleClick} val="6" />
            <Key actionClickButton={this.handleClick} val="7" />
            <Key actionClickButton={this.handleClick} val="8" />

            <div className="button next" onClick={this.handleErase}>Стереть</div>
          </div>
        </div>
      );
    }else{
      // return(
      //   <div className="keyboardWrapper Numbers">
      //     <div className="Keyboard numbers">
      //       <div className="row">
      //         <div className="innerTable">
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Q" />
      //             <Key actionClickButton={this.handleClick} val="W" />
      //             <Key actionClickButton={this.handleClick} val="E" />
      //             <Key actionClickButton={this.handleClick} val="R" />
      //             <Key actionClickButton={this.handleClick} val="T" />
      //             <Key actionClickButton={this.handleClick} val="Y" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="U" />
      //             <Key actionClickButton={this.handleClick} val="I" />
      //             <Key actionClickButton={this.handleClick} val="O" />
      //             <Key actionClickButton={this.handleClick} val="P" />
      //             <Key actionClickButton={this.handleClick} val="." />
      //             <Key actionClickButton={this.handleClick} val="@" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="A" />
      //             <Key actionClickButton={this.handleClick} val="S" />
      //             <Key actionClickButton={this.handleClick} val="D" />
      //             <Key actionClickButton={this.handleClick} val="F" />
      //             <Key actionClickButton={this.handleClick} val="G" />
      //             <Key actionClickButton={this.handleClick} val="H" />

      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="J" />
      //             <Key actionClickButton={this.handleClick} val="K" />
      //             <Key actionClickButton={this.handleClick} val="L" />
      //             <Key actionClickButton={this.handleClick} val="Z" />
      //             <Key actionClickButton={this.handleClick} val="X" />
      //             <Key actionClickButton={this.handleClick} val="C" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="V" />
      //             <Key actionClickButton={this.handleClick} val="B" />
      //             <Key actionClickButton={this.handleClick} val="N" />
      //             <Key actionClickButton={this.handleClick} val="M" />
      //             <Key actionClickButton={this.handleClick} val="1" />
      //             <Key actionClickButton={this.handleClick} val="2" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="3" />
      //             <Key actionClickButton={this.handleClick} val="4" />
      //             <Key actionClickButton={this.handleClick} val="5" />
      //             <Key actionClickButton={this.handleClick} val="6" />
      //             <Key actionClickButton={this.handleClick} val="7" />
      //             <Key actionClickButton={this.handleClick} val="8" />
      //           </div>
      //         </div>
      //       </div>
      //       <div className="row" style={{height: "14.285%"}}>
      //         <div className="innerTable">
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" val="9" style={{width: "12%"}} />
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" val="0" style={{width: "13.3%"}} />
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" style={{width: "24.7%"}} probel="true" val=" " />
      //           <div className="serviceClass button"  style={{width: "25%", fontSize: "25px"}} onClick={this.handleErase}>Стереть</div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      return null
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/LettersLat/index.jsx
 **/